import React from 'react';
import { mergeStyleSets } from '@fluentui/react';
import { boroondaraPalette } from '../../theme/boroondaraTheme';
import { CHOROPLETH_COLORS } from './constants';
import { ChoroplethMeta } from './types';

const p = boroondaraPalette;

interface ChoroplethLegendProps {
  meta: ChoroplethMeta | null;
}

const styles = mergeStyleSets({
  legend: {
    position: 'absolute' as any,
    bottom: 24,
    left: 12,
    zIndex: 1000,
    background: 'rgba(255,255,255,0.94)',
    borderRadius: 6,
    padding: '10px 14px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
    border: `1px solid ${p.borderSoft}`,
    minWidth: 140,
  },
  title: {
    fontSize: 11,
    fontWeight: 600,
    color: p.text2,
    marginBottom: 6,
    textTransform: 'uppercase',
    letterSpacing: '0.04em',
  } as any,
  bar: {
    display: 'flex',
    height: 12,
    borderRadius: 2,
    overflow: 'hidden',
    marginBottom: 4,
  },
  segment: {
    flex: 1,
  },
  labels: {
    display: 'flex',
    justifyContent: 'space-between',
    fontSize: 10,
    color: p.text3,
  },
});

function formatLegendValue(val: number): string {
  if (val >= 1000000) return `${(val / 1000000).toFixed(1)}M`;
  if (val >= 1000) return `${(val / 1000).toFixed(1)}K`;
  if (val % 1 !== 0) return val.toFixed(2);
  return val.toLocaleString();
}

export default function ChoroplethLegend({ meta }: ChoroplethLegendProps) {
  if (!meta) return null;

  const metricLabel = meta.metric
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase());

  return (
    <div className={styles.legend}>
      <div className={styles.title}>{metricLabel}</div>
      <div className={styles.bar}>
        {CHOROPLETH_COLORS.map((color, i) => (
          <div key={i} className={styles.segment} style={{ background: color }} />
        ))}
      </div>
      <div className={styles.labels}>
        <span>{formatLegendValue(meta.min)}</span>
        <span>{formatLegendValue(meta.max)}</span>
      </div>
    </div>
  );
}
